<template>
     <div class="committees-container">
        <TitlePart text="Conference Chairs"/>
            <div class="left-aligned-text">
                <p style="line-height:150%">
                Dr. Xintao Liu, The Hong Kong Polytechnic University, Hong Kong<br>
                Dr. Lei Zou, Texas A&M University, USA<br>
                Prof. Liang Zhai, Chinese Academy of Surveying and Mapping, China<br>
                Prof. Angela Yao, University of Georgia, USA<br>
                Prof. Bin Jiang, The Hong Kong University of Science and Technology (Guangzhou), China<br>
                </p>
            </div>
    </div>
    <div class="committees-container">
        <br>    
        <TitlePart text="Local Organizing Committee"/>
            <div class="left-aligned-text">
                <p style="line-height:150%">
                <strong>Advisor</strong><br>
                Ben Chan, Research Institute for Land and Space, The Hong Kong Polytechnic University
                </p>
                <p style="line-height:150%">
                <strong>Members</strong><br>
                Raymond Wai Man CHOI, Lands Department, Hong Kong SAR<br>
                Yang Xu, The Hong Kong Polytechnic University<br>
                Xiaolin Zhu, The Hong Kong Polytechnic University<br>
                Serein Yao Han,The Hong Kong Polytechnic University<br>
                Ningyezi Peng, The Hong Kong Polytechnic University<br>
                Zhiyang Xiao, The Hong Kong Polytechnic University<br>
                Jian Liu, The Hong Kong Polytechnic University<br>
                Xinyue Gu, The Hong Kong Polytechnic University
                </p>
                <p style="line-height:150%">
                <strong>Secretary</strong><br>
                Zidong Yu, The Hong Kong Polytechnic University
                </p>
            </div>
    </div>
    <div class="committees-container">
            <TitlePart text="Scientific Program Committee"/>
            <div class="left-aligned-text">
                <p style="line-height:150%">
                <!-- <strong>President</strong><br> -->
                
                <!-- <strong>Secretary-General</strong><br> -->
               
                <!-- <strong>Members</strong><br> -->
                Alex Kent, Canterbury Christ Church University, United Kingdom<br>
                Amy Griffin, Royal Melbourne Institute of Technology (RMIT) University, Australia<br>
                Angela Yao, University of Georgia, United States<br>
                Antoni Moore, University of Otago, New Zealand<br>
                Britta Ricker, Utrecht University, The Netherlands<br>
                Christophe Claramunt, Ecole Navale, France<br>
                Christophe Lienert, Federal Office for the Environment, Switzerland<br>
                Dariusz Dukaczewski, Institute of Geodesy and Cartography, Poland<br>
                Dušan Petrovič, University of Ljubljana, Slovenia<br>
                Emmanuel Stefanakis, University of Calgary, Canada<br>
                Florian Ledermann, TU Wien, Austria<br>
                Georg Gartner, University of Technology, Austria<br>
                Haosheng Huang, Ghent University, Belgium<br>
                Hua Liao, Hunan Normal University, China<br>
                Jie Shen, Nanjing Normal University, China<br>
                Jing Yao, University of Glasgow, United Kingdom<br>
                Jiping Liu, Chinese Academy of Surveying and Mapping, China<br>
                Jonathan Li, University of Waterloo, Canada<br>
                Jukka M. Krisp, Augsburg University,Germany<br>
                Liqiu Meng, Technical University of Munich, Germany<br>
                Mátyás Gede, Loránd University, Hungary<br>
                Min Chen, Nanjing Normal University, China<br>
                Monika Sester, Leibniz University Hannover, Germany<br>
                Otakar Čerba, University of West Bohemia, Czech Republic<br>
                Patrick Kennelly, United States<br>
                Qingyun Du, Wuhan University, China<br>
                Ron Furness, IIC Technologies Pty Ltd, Australia<br>
                Ruisheng Wang, University of Calgary, Canada<br>
                Serena Coetzee, University of Pretoria, South Africa<br>
                Song Gao, University of Wisconsin-Madison, USA<br>
                Taien Ng-Chan, York University, Canada<br>
                Tao Wang, Capital Normal University, China<br>
                Thomas Schulz, Swiss Federal Statistical Office, Switzerland<br>
                Toru Ishikawa, Toyo University, Japan<br>
                Toshihiro Osaragi, Tokyo Institute of Technology, Japan<br>
                Tumasch Reichenbacher, Switzerland<br>
                Ming-Chih Wang, University of Taipei, Taiwan<br>
                Vít Voženílek, Palacký University Olomouc, Czech Republic<br>
                Wei Huang, Tongji University, China<br>
                Weihua Dong, Beijing Normal University, China<br>
                Wolfgang Kainz, University of Vienna, Austria<br>
                Young-Hoon Kim, Korea National University of Education, South Korea<br>
                Zhe (Sarina) Zhang, Texas A&M University, USA<br>
                </p>
            </div>
            <br>
            <br>
            <br>
    </div>
</template>

<script>
import TitlePart from '@/components/TitlePart/TitlePart.vue'
    export default {
        components:{
            TitlePart
        }
    }
</script>

<style lang="less" scoped>
    @import "./style.less" ;
</style>